// Import ES6 Promise
import 'es6-promise/auto'

// Import System requirements
import Vue from 'vue'
import VueRouter from 'vue-router'
import {sync} from 'vuex-router-sync'
import routes from './routes'
import store from './store'

// Vue Matrial
import VueMaterial from 'vue-material'
import {MdButton, MdContent, MdTabs} from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import 'vue-croppa/dist/vue-croppa.css'
import Croppa from 'vue-croppa'
import Multiselect from 'vue-multiselect'
import { TooltipPlugin } from '@syncfusion/ej2-vue-popups'
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns'
import InputColorPicker from 'vue-native-color-picker'
import CKEditor from 'ckeditor4-vue'

Vue.use(CKEditor)

Vue.use(InputColorPicker)

Vue.use(MultiSelectPlugin)

Vue.use(TooltipPlugin)

var VueCookie = require('vue-cookie')
// Tell Vue to use the plugin
Vue.use(VueCookie)
Vue.component('multiselect', Multiselect)
Vue.use(Croppa)

// Import Helpers for filters
import {domain, count, prettyDate, pluralize} from './filters'

// Import Views - Top level
import AppView from './components/App.vue'

// Sweet Alert
import Swal from 'sweetalert2'

// Import Install and register helper items
import VueFileAgent from 'vue-file-agent'
import 'vue-file-agent/dist/vue-file-agent.css'
import '@syncfusion/ej2-vue-popups/styles/material.css'
import '@syncfusion/ej2-base/styles/material.css'
import '@syncfusion/ej2-inputs/styles/material.css'
import '@syncfusion/ej2-vue-dropdowns/styles/material.css'
import '@syncfusion/ej2-buttons/styles/material.css'
import VueHtmlToPaper from 'vue-html-to-paper'
Vue.use(VueHtmlToPaper, options)
// Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet

import auth from './packages/auth/auth.js'

import VueAnalytics from 'vue-analytics'
import BackToTop from 'vue-backtotop'

import * as firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/analytics'

const firebaseConfig = {
  apiKey: 'AIzaSyBIEiBem1NtydZ5-29LG-XK3Mp-m4UsM2Y',
  authDomain: 'rcp-smart-app.firebaseapp.com',
  databaseURL: 'https://rcp-smart-app.firebaseio.com',
  projectId: 'rcp-smart-app',
  storageBucket: 'rcp-smart-app.appspot.com',
  messagingSenderId: '488566739726',
  appId: '1:488566739726:web:dbf7bd58db21a140b7bd5f',
  measurementId: 'G-5RLMWYZBR7'
}

firebase.initializeApp(firebaseConfig)
firebase.analytics()

Vue.config.productionTip = false

// alias
Vue.prototype.$analytics = firebase.analytics()

Vue.use(VueAnalytics, {
  id: 'UA-158707644-1'
})

Vue.use(BackToTop)

Vue.use(auth)

Vue.use(Loading)

Vue.use(VueFileAgent)

Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('prettyDate', prettyDate)
Vue.filter('pluralize', pluralize)

Vue.use(VueRouter)
Vue.use(VueMaterial)
Vue.use(MdButton)
Vue.use(MdContent)
Vue.use(MdTabs)

window.Swal = Swal
window.Fire = new Vue()

const toast = Swal.mixin({
  toast: true,
  position: 'bottom-start',
  showConfirmButton: false,
  timer: 7000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=no',
    'scrollbars=no'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}

window.toast = toast

// Routing logic
var router = new VueRouter({
  routes: routes,
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || {x: 0, y: 0}
  }
})

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.forAuthUser)) {
    if (!Vue.auth.isAuthenticated() && Vue.auth.getRole() !== 'Customer') {
      next({
        path: '/user/login'
      })
      window.location.reload()
    } else {
      if (Vue.auth.getRole() === 'Admin') {
        next({
          path: '/admin/overview'
        })
        window.location.reload()
      } else {
        next()
      }
    }
  } else if (to.matched.some(record => record.meta.forAuthAdmin)) {
    if (!Vue.auth.isAuthenticated() && Vue.auth.getRole() !== 'Admin') {
      next({
        path: '/admin/login'
      })
      window.location.reload()
    } else {
      if (Vue.auth.getRole() === 'Customer') {
        next({
          path: '/'
        })
        window.location.reload()
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

sync(store, router)

// eslint-disable-next-line no-new
new Vue({
  el: '#root',
  router: router,
  store: store,
  render: h => h(AppView)
})



// WEBPACK FOOTER //
// ./src/main.js